import { ResultsBlock } from "./ResultsBlock";

export default ResultsBlock;